import React, { useContext, useMemo } from 'react';
import MUIDataTable, { Responsive } from 'mui-datatables';
import { OptionsDefault } from '../../../components/util/optionsTabelaDefault/.mixins/index';
import { tableHeaders } from './const';
import { useFormsContext } from '../context/FormsProvider';
import { InjectedRouter } from 'react-router';
import { AuthContext } from 'contexts/AuthContext';
import { CircularProgress } from '@material-ui/core';
import { useStyles } from './styles';

type Props = {
  router: InjectedRouter;
};

export const FormsTable = ({ router }: Props) => {
  const {
    data,
    page,
    tableChangePage,
    isDataLoading,
    supplierLoading,
    isLoadingCancelForm,
    isLoadingGetSuppliersAnswers
  } = useFormsContext();
  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);
  const styles = useStyles();

  const count = useMemo(() => data[0]?.totalRows || 0, [data]);
  const loading = useMemo(() => {
    return isDataLoading || supplierLoading || isLoadingCancelForm || isLoadingGetSuppliersAnswers;
  }, [isDataLoading, supplierLoading]);

  if (loading) return <CircularProgress className={styles.loadingCircular} />;
  return (
    <MUIDataTable
      key={page - 1}
      columns={tableHeaders({ router, isVisaoTok })}
      data={data}
      title=""
      options={{
        ...OptionsDefault,
        responsive: 'scrollFullHeight' as unknown as Responsive,
        selectableRows: 'none',
        serverSide: true,
        rowsPerPage: 5,
        count,
        page: page - 1,
        onTableChange: (action, tableState) => {
          if (action == 'changePage') {
            tableChangePage(tableState.page);
          }
        }
      }}
    />
  );
};
